<div class="animated fadeInRight">
    <!-- MENU DE TITULOS -->
    <app-lfsa-card-v2
      [titulo]      = "DAT_TITULOS.titulo"
      [modulo]      = "DAT_TITULOS.modulo"
      [tituloCard]  = "DAT_TITULOS.tituloCardListar"
      [innTemplate] = "enviarTemplateEdit"
      [innTemplateButton]="innTemplateButton">
    </app-lfsa-card-v2>
    <!-- MENU DE TITULOS -->
  
    <!-- OPCIONES BOTONES IZQUIERDO -->
    <ng-template #innTemplateButton>
      <div class="col-md-6 mb-2">
        <div class="pagetitle">
          <div class="btn-group-justified btn-group" style="float: right;">
            <button (click)="nuevo()" class="btn btn-primary"> <i aria-hidden="true" class="fa fa-plus"></i> Agregar </button>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- OPCIONES BOTONES IZQUIERDO -->
  
    <!-- GRILLA -->
    <ng-template #enviarTemplateEdit>
      <div class="form-group col-md-12">
          <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter " (keyup)="onQuickFilterChanged() " #quickFilter />
          <br>
          <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
          <ag-grid-angular #agGrid (gridReady)="onGridReady($event)"  
                            [id]    ="DAT_AG_GRID.id" 
                            [class] ="DAT_AG_GRID.class" 
                            [ngStyle]="DAT_AG_GRID.style" 
                            [rowData]="rowData" 
                            [columnDefs]="columnDefs"
                            [pagination]="DAT_AG_GRID.pagination" 
                            [rowHeight]="DAT_AG_GRID.rowHeight"
                            [paginationPageSize]="DAT_AG_GRID.pagina"
                            [allowContextMenuWithControlKey]="true"
                            [frameworkComponents]="frameworkComponents" >
          </ag-grid-angular>
      </div>
    <!-- GRILLA -->
    </ng-template>
  </div>
  
  <!-- MODAL -->
  <app-lfsa-modal [innTemplate]= "abrirModal" [classModal]= "'modal-dialog modal-lg'" 
                [idButton]="'abrirModal'" [idClose]="'cerrarModal'" [titulo]="titleModal"
                [titulo]="'Configuración de Feriados'" >
  </app-lfsa-modal>
    
  <ng-template #abrirModal>
    <div class="container-fluid">
        <!-- FORMULARIO -->
        <form [formGroup]="formulario" novalidate class="form-group"> 
            <div class="row">
                <div class="col">
                    <app-lfsa-input formControlName="idConfig" [label]="'*id Configuración'" [id]="'idConfig'" [control]="formulario.get('idConfig')" 
                        [type]="'number'" class="form-control-sm" [isReadOnly]="true">
                    </app-lfsa-input>
                </div>
                <div class="col">
                    <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [label]="'* Selección de bancos'" 
                                formControlName="bancoId" [comboBox]="listBancos" [id]="'bancoId'" 
                                [control]="this.formulario.get('bancoId') | formControl" 
                                [idOpcion]="'idBanco'" [opcion]="'descripcionBanco'" >
                    </app-lfsa-combo-box>
                </div>
                <div class="col">
                    <app-lfsa-input formControlName="fechaInicio" [label]="'Fecha inicio feriado'" [id]="'fechaInicio'" [control]="formulario.get('fechaInicio')" 
                        [type]="'date'" class="form-control-sm">
                    </app-lfsa-input>
                </div>
                <div class="col">
                    <app-lfsa-input formControlName="fechaFin" [label]="'Fecha fin feriado'" [id]="'fechaFin'" [control]="formulario.get('fechaFin')" 
                        [type]="'date'" class="form-control-sm">
                    </app-lfsa-input>
                </div>

                <app-lfsa-botones-formulario 
                    (devolverAccion) ="acciones($event)" 
                    [formularioValido] ="formulario.invalid" 
                    [loading]="loading" [textBoton]="'Aprobar'" class="row p-3">
                </app-lfsa-botones-formulario>
            </div>
        </form>
    </div>
  </ng-template>
  <!-- END MODAL --> 
